<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <ModalComponent
            :name="name"
            :title="title"
            @close="() => close(false)"
        >
            <template>
                <div class="row">
                    <div class="col-12 mb-2">
                        <h3 class="font-weight-bold">Se anularan los siguientes productos:</h3>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
                            <table class="table table-hover text-nowrap">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Descripción</th>
                                        <th class="text-center">Código QR</th>
                                        <th class="text-center">Precio Ut</th>
                                        <th class="text-center">Unidades</th>
                                        <th class="text-center">Precio total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="producto in products">
                                        <tr :key="producto.id" v-if="!producto.deleted_at">
                                            <td>{{ producto.nombre_producto }}</td>
                                            <td>{{ producto.descripcion_producto }}</td>
                                            <td class="text-center">{{ producto.qr_code }}</td>
                                            <td class="text-center">{{ producto.price | formatear_precio }}</td>
                                            <td class="text-center">{{ producto.units }}</td>
                                            <td class="text-center">{{ producto.price * producto.units | formatear_precio }}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <h1 class="font-weight-bold text-uppercase">¿{{ title }}?</h1>
                    </div>
                    <div class="col-12 text-center">
                        <div v-if="pedido.modalidad == 1">
                            <template>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(false)">ANULAR</Button>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(true)">ANULAR SIN GG</Button>
                            </template>                        
                        </div>
                        <div v-else-if="evento_pasado == false">
                            <template v-if="pedido.metodo_pago == 1 || pedido.metodo_pago == 3">
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(false)">ANULAR</Button>
                            </template>                 
                            <ocultar-con-password message="Para anular el pedido con gastos de gestión tienes que poner una contraseña:" v-else>
                                <template>
                                    <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(false)">ANULAR</Button>
                                </template>
                            </ocultar-con-password>
                            <template>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(true)">ANULAR SIN GG</Button>
                            </template>
                        </div>
                        <div v-else-if="evento_pasado == true">
                            <ocultar-con-password :message="'Para anular el ' +  (title.includes('pedido') ? 'pedido' : 'producto') + ' tienes que poner una contraseña:'">
                                <template>
                                    <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(false)">ANULAR</Button>
                                    <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularPedido(true)">ANULAR SIN GG</Button>
                                </template>
                            </ocultar-con-password>
                        </div>
                    </div>
                </div>
            </template>
        </ModalComponent>
    </ValidationObserver>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import OcultarConPassword from "@/components/backend/components/OcultarConPassword.vue";

export default {
    props: {
        evento_id: { type: Number, required: true },
        sesion_id: { type: Number, required: true },
        producto_id: { type: Number, required: false },
        evento_pasado: { type: Boolean, required: true },
        pedido: { type: Object, required: true },
        title: { type: String, required: true },
        name: { type: String, required: true }
    },
    data() {
        return {
            email: null,
            loading: false,
            disableButton: false
        }
    },
    methods: {
        close() {
            this.$emit('close', this.name);
        },
        anularPedido(sin_gd) {
            this.loading = true;

            const data = {
                evento_id: this.evento_id,
                sesion_id: this.sesion_id,
                user_order_id: this.pedido.id,
                sin_gd: sin_gd
            };

            if (this.producto_id) {
                data.user_products_ids = [this.producto_id];
            }

            this.disableButton = true;

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.pedido.productos.anular'), data).then(res => {
                this.$toast.success(res.data.message);
                this.$emit('anulado');
                this.close();
            }).catch(error => {
                if (error.response.data.message) {
                    this.$toast.error(error.response.data.message);
                }
            }).finally(() => this.loading = false, this.disableButton = false);
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.anularPedido();
            }
        }
    },
    computed: {
        products() {
            if (this.producto_id) {
                return this.pedido.products.filter(producto => producto.id === this.producto_id);
            }

            return this.pedido.products;
        }
    },
    components: {
        ModalComponent, OcultarConPassword
    }
}
</script>

<style>
::-webkit-scrollbar {
  width: 20px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}
</style>